import { Solution } from '@energiebespaarders/constants';
import { testimonials } from '../HomePage/testimonials';

export type InstallerLandingReview = {
  name: string;
  quote: string;
  imageUrl: string;
  rating?: number;
  city?: string;
  solution?: Solution;
};

export const customerTestimonials: InstallerLandingReview[] = testimonials.map(t => ({
  ...t,
  imageUrl: t.photo,
  rating: 5,
}));

export const installerTestimonials: InstallerLandingReview[] = [
  {
    name: 'Lammertink Isolatie',
    solution: Solution.WallInsulation,
    quote:
      'Energiebespaarders denkt goed mee om processen te verbeteren. Zo zorgen we er samen voor dat de samenwerking zo strak mogelijk verloopt.',
    imageUrl:
      'https://res.cloudinary.com/solvari/image/upload/c_pad,f_auto,h_320,q_auto,w_480/v1617099946/production/images/nl-NL/logo/lammertink-isolatie-image-name',
  },
  {
    name: 'Helios Solar',
    solution: Solution.PvSystem,
    quote:
      'Een prettige samenwerking. We hoeven zelf niet meer te schouwen en kunnen direct aan de slag!',
    imageUrl:
      'https://res.cloudinary.com/solvari/image/upload/c_pad,f_auto,h_320,q_auto,w_480/v1496130323/production/images/nl-NL/logo/helios-solar-logo',
  },
];

// PureWarmte
// https://api.energiebeheerders.nl/api/v2/files/e0f0246a-a8f8-4efd-8906-b85283b8ab5c.png

// Atama
// https://api.energiebeheerders.nl/api/v2/files/49098bd3-e98d-46c7-aeae-7acd91c223c2.png

// Duits Iso
// https://api.energiebeheerders.nl/api/v2/files/17814e60-6c19-4cdf-997c-fcbb355d097d.png

// Breman
// https://api.energiebeheerders.nl/api/v2/files/38f6eacb-b19b-4768-b60e-15b824fcce4a.png
